import { ElementModel } from "src/common";

export class ElementViewModel {
  element: ElementModel;
  isValid: any;
  isValueValid: any;
  getElement: any;
  delete: any;
  getValue: any;
  onElementOrder: any;
}

export enum ElementMode {
	Definition,
	Execution
}

export enum ElementOrderDirection {
  Up,
  Down
}
